module.exports = __webpack_public_path__ + "img/AllFlights.ea10b233.png";